import React from 'react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Mousewheel, Keyboard } from 'swiper'
import { CarouselStyle, CentralizeCards } from './style'

export interface SwiperWrapperProps {
  carouselItems: JSX.Element[]
  breakpoints: any
  arrowColor?: string
  swipeOnMouseWheel?: boolean
  swiperId?: string
}

export const SwiperWrapper = ({
  carouselItems,
  breakpoints,
  arrowColor = '#FF4F1C',
  swipeOnMouseWheel = true,
  swiperId = 'default'
}: SwiperWrapperProps): JSX.Element => {
  const prevButtonId = `prevButton-${swiperId}`
  const nextButtonId = `nextButton-${swiperId}`

  return (
    <CarouselStyle arrowColor={arrowColor} isMenu={false}>
      <Swiper
        keyboard={{
          enabled: true
        }}
        breakpoints={breakpoints}
        modules={[Mousewheel, Navigation, Keyboard]}
        navigation={{
          nextEl: `#${nextButtonId}`,
          prevEl: `#${prevButtonId}`
        }}
        allowSlideNext={true}
        mousewheel={swipeOnMouseWheel}
        grabCursor={true}
        pagination={{ type: 'bullets', clickable: true }}
      >
        {carouselItems.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <CentralizeCards>
                {item}
              </CentralizeCards>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <div id={prevButtonId} className={'swiper-button-prev'}/>
      <div id={nextButtonId} className={'swiper-button-next'}/>
    </CarouselStyle>
  )
}
